module.exports = __webpack_public_path__ + "static/media/start-test-bg.c66de821.png";